import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getDiscordAvatarUrl } from "../utils/discord";
import { COMMUNITY_INVITE } from "../data/links";
import { startLogin } from "../utils/session";

export default function SiteNav({ user, onLogout, isBotOwner = false }) {
  const location = useLocation();
  const [imgError, setImgError] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const avatarSrc = imgError
    ? getDiscordAvatarUrl({ id: user?.id })
    : getDiscordAvatarUrl(user);

  const login = () => {
    startLogin(`${location.pathname}${location.search || ""}`);
  };

  const profileActive =
    location.pathname === "/profile" ||
    location.pathname.startsWith("/profile/") ||
    (user?.id && location.pathname === `/u/${user.id}`);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header className="site-nav">
      <div className="site-nav-inner">
        <Link to="/" className="site-brand">
          <span className="site-brand-mark">☾</span>
          <span>Nocturne</span>
        </Link>

        <nav className="site-links site-links-desktop">
          <Link to="/" className={location.pathname === "/" ? "active" : ""}>
            Home
          </Link>
          <Link to="/profile" className={profileActive ? "active" : ""}>
            Profile
          </Link>
          {user && (
            <Link
              to="/servers"
              className={location.pathname === "/servers" ? "active" : ""}
            >
              My Servers
            </Link>
          )}
          <Link
            to="/help"
            className={location.pathname === "/help" ? "active" : ""}
          >
            Commands
          </Link>
          <Link
            to="/donate"
            className={location.pathname === "/donate" ? "active" : ""}
          >
            Support
          </Link>
          {isBotOwner ? (
            <Link
              to="/admin"
              className={location.pathname === "/admin" ? "active" : ""}
            >
              Admin
            </Link>
          ) : null}
          <a href={COMMUNITY_INVITE} target="_blank" rel="noreferrer">
            Community
          </a>
        </nav>

        <div className="site-user site-user-desktop">
          {user ? (
            <>
              <Link to="/profile" className="site-user-link">
                <img
                  src={avatarSrc}
                  alt=""
                  className="nav-avatar"
                  onError={() => setImgError(true)}
                />
                <span className="site-username">{user.username}</span>
              </Link>
              <button type="button" onClick={onLogout} className="logout-link">
                Logout
              </button>
            </>
          ) : (
            <button type="button" onClick={login} className="nav-login-btn">
              Log in with Discord
            </button>
          )}
        </div>

        <button
          type="button"
          className={`nav-menu-toggle${menuOpen ? " open" : ""}`}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {menuOpen && (
        <div className="site-mobile-menu">
          <Link
            to="/"
            className={location.pathname === "/" ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/profile"
            className={profileActive ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            Profile
          </Link>
          {user && (
            <Link
              to="/servers"
              className={location.pathname === "/servers" ? "active" : ""}
              onClick={() => setMenuOpen(false)}
            >
              My Servers
            </Link>
          )}
          <Link
            to="/help"
            className={location.pathname === "/help" ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            Commands
          </Link>
          <Link
            to="/donate"
            className={location.pathname === "/donate" ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            Support
          </Link>
          {isBotOwner ? (
            <Link
              to="/admin"
              className={location.pathname === "/admin" ? "active" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Admin
            </Link>
          ) : null}
          <a
            href={COMMUNITY_INVITE}
            target="_blank"
            rel="noreferrer"
            onClick={() => setMenuOpen(false)}
          >
            Community
          </a>

          {user ? (
            <div className="site-mobile-user">
              <Link
                to="/profile"
                className="site-user-link"
                onClick={() => setMenuOpen(false)}
              >
                <img
                  src={avatarSrc}
                  alt=""
                  className="nav-avatar"
                  onError={() => setImgError(true)}
                />
                <span className="site-username">{user.username}</span>
              </Link>
              <button
                type="button"
                onClick={onLogout}
                className="logout-link"
              >
                Logout
              </button>
            </div>
          ) : (
            <button type="button" onClick={login} className="nav-login-btn">
              Log in with Discord
            </button>
          )}
        </div>
      )}
    </header>
  );
}
